var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',{staticClass:"d-flex justify-center"},[_vm._v("You don't have permission to access this page")])])}
var staticRenderFns = []

export { render, staticRenderFns }